export default {
	INTERVIEWS_PACKAGE: 'Interviews Package',
	SUCCESSFULL_HIRE: 'Successfull Hire'
};
